<template>
    <div v-if="canShow">

        <v-tour name="sideBarTour" :steps="steps" :options="myOptions" :callbacks="myCallbacks">
            <template slot-scope="tour" >
                <transition name="fade">
                    <v-step
                        class="bg-primary"
                        style="background: linear-gradient(180deg, rgba(0,0,0,0.3799720571822479) 0%, rgba(0,123,255,0) 50%);"
                        v-if="tour.steps[tour.currentStep]"
                        :key="tour.currentStep"
                        :step="tour.steps[tour.currentStep]"
                        :previous-step="tour.previousStep"
                        :next-step="tour.nextStep"
                        :stop="tour.stop"
                        :skip="tour.skip"
                        :start="tour.start"
                        :finish="tour.finish"
                        :is-first="tour.isFirst"
                        :is-last="tour.isLast"
                        :labels="tour.labels"
                        :highlight="tour.highlight"
                    >
                        <div slot="header" class="fw-bolder text-start mb-2">
                            {{ tour.steps[tour.currentStep].header.title }}
                        </div>
                        <div slot="content" class="text-start mb-2" v-html="tour.steps[tour.currentStep].content">
                        </div>
                        <div slot="actions" v-if="tour.isFirst" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <button @click="tour.nextStep" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonNext }}</button>
                        </div>
                        <div slot="actions" v-if="!tour.isLast && !tour.isFirst" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <div>
                                <button @click="tour.previousStep" class="btn btn-sm btn-link text-secondary rounded-pill">{{ tour.labels.buttonPrevious }}</button>
                                <button @click="tour.nextStep" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonNext }}</button>
                            </div>
                        </div>
                        <div slot="actions" v-if="tour.isLast" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <div>
                                <button @click="tour.previousStep" class="btn btn-sm btn-link text-secondary rounded-pill">{{ tour.labels.buttonPrevious }}</button>
                                <button @click="tour.stop" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonStop }}</button>
                            </div>
                        </div>
                        
                    </v-step>
                </transition>
              </template>
        </v-tour>
    </div>
</template>

<script>
export default {
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
        canShow: {
            type: Boolean,
            default: true,
        },
        start : {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            myOptions: {
                useKeyboardNavigation: false,
                labels: {
                    buttonSkip: 'Pular',
                    buttonPrevious: 'Anterior',
                    buttonNext: 'Próximo',
                    buttonStop: 'Finalizar'
                },
                highlight: true
            },
            myCallbacks: {
                onStop: this.stopOnboarding,
            },
            steps: [
                {
                    target: '#studentesPage',
                    header: {
                        title: 'Pagina de Alunos'
                    },
                    content: 'Aqui você pode ver e gerenciar todos os alunos da organização e realizar outras ações.',
                    params: {
                        placement: 'auto',
                        enableScrolling: false,
                    }
                },
                {
                    target: '#createStudentsButtonTour',
                    header: {
                        title: 'Criar alunos'
                    },
                    content: 'Neste botão você pode acessar o menu de cadastro de alunos, vejamos como fazer.',
                    params: {
                        placement: 'left',
                        enableScrolling: false,
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.$bvModal.hide('createStudent')
                        resolve('foo')
                    })
                },
                {
                    target: '#createStudentFormTour',
                    header: {
                        title: 'Adicionar Aluno'
                    },
                    content: 'São necessários pelo menos nome, e-mail, turma e uma senha para cadastrar um novo aluno.',
                    params: {
                        placement: 'left',
                        enableScrolling: true,
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.$root.$emit('createStudent')
                        resolve('foo')
                    })
                },
                {
                    target: '#createStudentAddButtonTour',
                    header: {
                        title: 'Finalizar cadastro'
                    },
                    content: 'Ao preencher todos os dados, clique em adicionar para finalizar o cadastro.',
                    params: {
                        placement: 'left',
                        enableScrolling: true,
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.$root.$emit('createStudent')
                        resolve('foo')
                    })
                },
                {
                    target: '#studentsTableTour',
                    header: {
                        title: 'Lista de Alunos'
                    },
                    content: 'Aqui ficarão listados todos os alunos cadastrados, juntamente com outras informações importantes.',
                    params: {
                        placement: 'top',
                        enableScrolling: false,
                    },
                    before: type => new Promise((resolve, reject) => {
                        this.$bvModal.hide('createStudent')
                        resolve('foo')
                    })
                },
                {
                    target: '#studentsFilterTour',
                    header: {
                        title: 'Filtros'
                    },
                    content: 'Também é possível realizar uma variedade de filtros dos alunos de acordo com sua necessidade.',
                    params: {
                        placement: 'top',
                        enableScrolling: false,
                    },
                },

            ]
        }
    },
    watch: {
        start(value) {
            if(value){
                this.$tours['sideBarTour'].start()
            }
        }
    },
    methods: {
        stopOnboarding(){
            this.$emit('finished')
        }
    },
    mounted() {
        
    }
}
</script>

<style>
.v-tour__target--highlighted {
    box-shadow: 0 0 0 9999px rgba(0,0,0,.5);
}
.v-step > .v-step__arrow{
    color: white;
    background-color: inherit;
}

</style>
